var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page d-flex align-items-center justify-content-center p-3"},[_c('error404')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }